import { sharedTheme } from './shared-theme'

export const plannerTheme = {
  palette: {
    primary: {
      main: '#00415A',
      contrastText: '#FFFFFF',
    },
    secondary: {
      main: '#0082B3',
      contrastText: '#FFFFFF',
    },
    success: {
      main: '#4caf50',
      contrastText: '#FFFFFF',
    },
    info: {
      main: '#2196f3',
      contrastText: '#FFFFFF',
    },
    warning: {
      main: '#ff9800',
      contrastText: '#FFFFFF',
    },
    error: {
      main: '#f44336',
      contrastText: '#FFFFFF',
    },
    ...sharedTheme.palette,
  },
  typography: {
    ...sharedTheme.typography,
  },
}
